import { __assign } from '../../../../tslib@2.4.1/node_modules/tslib/tslib.es6.js';
import { noCase } from '../../../../no-case@3.0.4/node_modules/no-case/dist.es2015/index.js';
function dotCase(input, options) {
  if (options === void 0) {
    options = {};
  }
  return noCase(input, __assign({
    delimiter: "."
  }, options));
}
export { dotCase };